module.exports = __webpack_public_path__ + "img/i-marketing-calendar-admin.80f57548.svg";